var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("MetaMask has an incorrect network")]),_vm._v(", change your network in MetaMask to "),_c('strong',[_vm._v(_vm._s(_vm.networkName)+".")])])
}
var staticRenderFns = []

export { render, staticRenderFns }